// import React, { useState } from "react";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";
// import "../css/CollectionReport.css";

// const staticCollections = [
//   {
//     id: 422,
//     loanId: 7,
//     emiNumber: 2,
//     emiAmount: 230,
//     principalComponent: 200,
//     interestComponent: 30,
//     dueDate: "2025-08-27T00:00:00.000Z",
//     status: "paid",
//     paymentDate: "2025-09-23T16:42:53.000Z",
//     outstanding: 9600,
//     customerName: "Rahul Sharma",
//     loanNumber: "MZBR00100007",
//   },
//   {
//     id: 423,
//     loanId: 8,
//     emiNumber: 1,
//     emiAmount: 500,
//     principalComponent: 400,
//     interestComponent: 100,
//     dueDate: "2025-09-05T00:00:00.000Z",
//     status: "paid",
//     paymentDate: "2025-09-23T17:00:00.000Z",
//     outstanding: 4500,
//     customerName: "Priya Verma",
//     loanNumber: "MZBR00100008",
//   },
//   {
//     id: 424,
//     loanId: 9,
//     emiNumber: 3,
//     emiAmount: 300,
//     principalComponent: 250,
//     interestComponent: 50,
//     dueDate: "2025-09-10T00:00:00.000Z",
//     status: "pending",
//     paymentDate: null,
//     outstanding: 2700,
//     customerName: "Amit Singh",
//     loanNumber: "MZBR00100009",
//   },
// ];

// const CollectionReport = () => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const totalPages = Math.ceil(staticCollections.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = staticCollections.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

//   // PDF Export
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.setFontSize(18);
//     doc.text("Company Collection Report", 14, 20);

//     const tableColumn = [
//       "#",
//       "Customer Name",
//       "Loan Number",
//       "EMI Number",
//       "EMI Amount",
//       "Principal",
//       "Interest",
//       "Outstanding",
//       "Due Date",
//       "Payment Date",
//       "Status",
//     ];

//     const tableRows = currentData.map((c, index) => [
//       startIndex + index + 1,
//       c.customerName,
//       c.loanNumber,
//       c.emiNumber,
//       c.emiAmount,
//       c.principalComponent,
//       c.interestComponent,
//       c.outstanding,
//       new Date(c.dueDate).toLocaleDateString("en-IN"),
//       c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
//       c.status,
//     ]);

//     doc.autoTable({
//       startY: 30,
//       head: [tableColumn],
//       body: tableRows,
//       theme: "grid",
//       headStyles: { fillColor: [99, 102, 241], textColor: 255 },
//       styles: { fontSize: 10, cellPadding: 3 },
//     });

//     doc.save("Collection_Report.pdf");
//   };

//   return (
//     <div className="CollectionReport-wrapper">
//       <h1 className="CollectionReport-title">📋 Collection Report</h1>

//       {/* Controls */}
//       <div className="CollectionReport-controls">
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//           </select>{" "}
//           entries
//         </label>

//         <button className="filter-btn" onClick={handleDownloadPDF}>
//           📄 Download PDF
//         </button>
//       </div>

//       {/* Table */}
//       <div className="CollectionReport-table-container">
//         <table className="CollectionReport-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Customer Name</th>
//               <th>Loan Number</th>
//               <th>EMI Number</th>
//               <th>EMI Amount</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Outstanding</th>
          
//               <th>Payment Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentData.length === 0 ? (
//               <tr>
//                 <td colSpan="11" className="CollectionReport-empty">
//                   ✅ No records found
//                 </td>
//               </tr>
//             ) : (
//               currentData.map((c, idx) => (
//                 <tr key={c.id}>
//                   <td>{startIndex + idx + 1}</td>
//                   <td>{c.customerName}</td>
//                   <td>{c.loanNumber}</td>
//                   <td>{c.emiNumber}</td>
//                   <td>₹{c.emiAmount.toLocaleString()}</td>
//                   <td>₹{c.principalComponent.toLocaleString()}</td>
//                   <td>₹{c.interestComponent.toLocaleString()}</td>
//                   <td>₹{c.outstanding.toLocaleString()}</td>
                
//                   <td>{c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-"}</td>
//                   <td>
//                     <span className={`CollectionReport-status ${c.status === "pending" ? "pending" : "paid"}`}>
//                       {c.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="CollectionReport-pagination">
//         <button className="pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>
//           ⬅ Prev
//         </button>
//         <span className="pagination-info">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button className="pagination-btn" onClick={handleNext} disabled={currentPage === totalPages}>
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CollectionReport;
import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import "../css/CollectionReport.css";

const API_URL = "https://narrowitsolution.in/api/loan-emi/";

const CollectionReport = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // 🔹 Fetch data from API
  useEffect(() => {
      const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

    const fetchCollections = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_URL}collection-sheet?superAdminId=${superAdminId}`);
        if (res.data && res.data.collections) {
          setCollections(res.data.collections);
        }
      } catch (error) {
        console.error("Error fetching collection report:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCollections();
  }, []);

  // 🔹 Pagination
  const totalPages = Math.ceil(collections.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = collections.slice(startIndex, startIndex + rowsPerPage);

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

  // // 🔹 PDF Export
  // const handleDownloadPDF = () => {
  //   const doc = new jsPDF();
  //   doc.setFontSize(18);
  //   doc.text("Company Collection Report", 14, 20);

  //   const tableColumn = [
  //     "#",
  //     "Customer Name",
  //     "Loan Number",
  //     "EMI Number",
  //     "EMI Amount",
  //     "Principal",
  //     "Interest",
  //     "Outstanding",
  //     "Due Date",
  //     "Payment Date",
  //     "Status",
  //   ];

  //   const tableRows = currentData.map((c, index) => [
  //     startIndex + index + 1,
  //     c.customerName,
  //     c.loanNumber,
  //     c.emiNumber,
  //     `₹${c.emiAmount.toLocaleString()}`,
  //     `₹${c.principalComponent.toLocaleString()}`,
  //     `₹${c.interestComponent.toLocaleString()}`,
  //     `₹${c.outstanding.toLocaleString()}`,
  //     new Date(c.dueDate).toLocaleDateString("en-IN"),
  //     c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
  //     c.status,
  //   ]);

  //   autoTable(doc,{
  //     startY: 30,
  //     head: [tableColumn],
  //     body: tableRows,
  //     theme: "grid",
  //     headStyles: { fillColor: [99, 102, 241], textColor: 255 },
  //     styles: { fontSize: 10, cellPadding: 3 },
  //   });

  //   doc.save("Collection_Report.pdf");
  // };





  // 🔹 PDF Export (Professional Black & White Design)
const handleDownloadPDF = () => {
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("📋 Company Collection Report", 14, 18);

  const tableColumn = [
    "#",
    "Customer Name",
    "Loan Number",
    "EMI Number",
    "EMI Amount",
    "Principal",
    "Interest",
    "Outstanding",
    "Due Date",
    "Payment Date",
    "Status",
  ];

  const tableRows = currentData.map((c, index) => [
    startIndex + index + 1,
    c.customerName,
    c.loanNumber,
    c.emiNumber,
    `₹${c.emiAmount.toLocaleString()}`,
    `₹${c.principalComponent.toLocaleString()}`,
    `₹${c.interestComponent.toLocaleString()}`,
    `₹${c.outstanding.toLocaleString()}`,
    new Date(c.dueDate).toLocaleDateString("en-IN"),
    c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
    c.status.toUpperCase(),
  ]);

  autoTable(doc, {
    startY: 28,
    head: [tableColumn],
    body: tableRows,
    theme: "grid",
    headStyles: {
      fillColor: [0, 0, 0], // Black header
      textColor: [255, 255, 255], // White text
      fontStyle: "bold",
    },
    styles: {
      font: "helvetica",
      fontSize: 9,
      cellPadding: 3,
      lineColor: [0, 0, 0], // Black borders
      lineWidth: 0.1,
      textColor: [0, 0, 0],
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240], // Light grey rows
    },
    bodyStyles: {
      textColor: [0, 0, 0],
    },
  });

  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(100);
    doc.text(
      `Page ${i} of ${pageCount}`,
      doc.internal.pageSize.getWidth() - 30,
      doc.internal.pageSize.getHeight() - 10
    );
    doc.text("Generated by Collection System", 14, doc.internal.pageSize.getHeight() - 10);
  }

  doc.save("Collection_Report.pdf");
};

  return (
    <div className="CollectionReport-wrapper">
      <h1 className="CollectionReport-title">📋 Collection Report</h1>

      {/* Controls */}
      <div className="CollectionReport-controls">
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>{" "}
          entries
        </label>

        <button className="filter-btn" onClick={handleDownloadPDF}>
          📄 Download PDF
        </button>
      </div>

      {/* Table */}
      <div className="CollectionReport-table-container">
        {loading ? (
          <p className="CollectionReport-loading">⏳ Loading data...</p>
        ) : (
          <table className="CollectionReport-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Customer Name</th>
                <th>Loan Number</th>
                <th>EMI Number</th>
                <th>EMI Amount</th>
                <th>Principal</th>
                <th>Interest</th>
                <th>Outstanding</th>
                <th>Due Date</th>
                <th>Payment Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td colSpan="11" className="CollectionReport-empty">
                    ✅ No records found
                  </td>
                </tr>
              ) : (
                currentData.map((c, idx) => (
                  <tr key={c.id}>
                    <td>{startIndex + idx + 1}</td>
                    <td>{c.customerName}</td>
                    <td>{c.loanNumber}</td>
                    <td>{c.emiNumber}</td>
                    <td>₹{c.emiAmount.toLocaleString()}</td>
                    <td>₹{c.principalComponent.toLocaleString()}</td>
                    <td>₹{c.interestComponent.toLocaleString()}</td>
                    <td>₹{c.outstanding.toLocaleString()}</td>
                    <td>{new Date(c.dueDate).toLocaleDateString("en-IN")}</td>
                    <td>{c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-"}</td>
                    <td>
                      <span className={`CollectionReport-status ${c.status === "pending" ? "pending" : "paid"}`}>
                        {c.status}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      {!loading && (
        <div className="CollectionReport-pagination">
          <button className="pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>
            ⬅ Prev
          </button>
          <span className="pagination-info">
            Page {currentPage} of {totalPages}
          </span>
          <button className="pagination-btn" onClick={handleNext} disabled={currentPage === totalPages}>
            Next ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default CollectionReport;
